import type { ProjectContext } from '@jira/router-resources__project-context/src/ProjectContext.types.tsx';
import type { Project } from '@jira/issue-create__issue-create-common-types/src/common/types/index.tsx';

export const getIssueCreateProjectForMount = (
	projectContext: ProjectContext | null,
): Project | null => {
	if (projectContext?.projectId) {
		return {
			label: projectContext.projectName,
			value: projectContext.projectId.toString(),
			iconUrl: '',
			projectKey: projectContext.projectKey,
			projectType: projectContext.projectType,
			isSimplified: projectContext.simplified,
		};
	}
	return null;
};
